var _effectorFileName = "/builds/gmini/front-ui-kit/src/Page403/Page403.tsx";
import { ErrorPageTemplate } from '../ErrorPageTemplate/ErrorPageTemplate';
import { LockIcon } from './LockIcon';
import { KeyPositioned, Page403Composition, Page403List, PathPositioned } from './Page403.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const Page403 = ({
  onReload,
  onLogout,
  onMainPage,
  customDescription
}) => /*#__PURE__*/_jsx(ErrorPageTemplate, {
  composition: /*#__PURE__*/_jsxs(Page403Composition, {
    children: [/*#__PURE__*/_jsx(LockIcon, {}), /*#__PURE__*/_jsx(PathPositioned, {}), /*#__PURE__*/_jsx(KeyPositioned, {})]
  }),
  mediumText: /*#__PURE__*/_jsx(_Fragment, {
    children: "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0435\u043C\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0437\u0430\u043A\u0440\u044B\u0442!"
  }),
  smallText: customDescription ? customDescription : /*#__PURE__*/_jsxs(_Fragment, {
    children: ["\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435:", /*#__PURE__*/_jsxs(Page403List, {
      children: [/*#__PURE__*/_jsx("li", {
        onClick: () => onReload === null || onReload === void 0 ? void 0 : onReload(),
        children: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"
      }), /*#__PURE__*/_jsx("li", {
        onClick: () => onMainPage === null || onMainPage === void 0 ? void 0 : onMainPage(),
        children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
      }), /*#__PURE__*/_jsx("li", {
        onClick: () => onLogout === null || onLogout === void 0 ? void 0 : onLogout(),
        children: "\u0412\u044B\u0439\u0442\u0438"
      })]
    })]
  }),
  errorCode: '403'
});